﻿import * as React from 'react';
import { PageOverlayProps } from './pageOverlay';

export interface IPageOverlayContext {
	onVisibilityChanged: (visible: boolean, properties?: PageOverlayProps) => void
	resize: () => void
}

export const PageOverlayContext = React.createContext<IPageOverlayContext>(null);